import React, { ReactNode } from 'react';
import { localeCountryKey } from 'helpers/constants/localeMapping';

interface CustomHeadProps {
  canonical?: string;
  title?: string;
  metaDescription?: string;
  metaKeywords?: string;
  children?: ReactNode;
  countrylocale?:string;
  alternateCountryUrlAvailable?:boolean;
  stylesheet?: string; 
}

export default function Head({ canonical, title, metaDescription, metaKeywords, children, countrylocale, alternateCountryUrlAvailable=true, stylesheet }: CustomHeadProps) {
  let alternateCountrylocale = "";
  let alternateCanonical =""; 
  if(canonical){
    if(countrylocale === localeCountryKey.nz && canonical.includes('experience-centre/auckland') ){
      alternateCountryUrlAvailable=false;
    }
    if(countrylocale === localeCountryKey.au && (canonical.includes('kitchen-laundry/kitchen-sinks-accessories') || canonical.includes('experience-centre/adelaide') ||
      canonical.includes('experience-centre/brisbane') || canonical.includes('experience-centre/perth') || canonical.includes('au/experience-centres') ||
      canonical.includes('terms-conditions') || canonical.includes('au/collection/urbane-universal-accessories') ||
      canonical.includes('clark') || canonical.includes('dorf'))){        
      alternateCountryUrlAvailable=false;
    }
    if(countrylocale === localeCountryKey.au){
      alternateCountrylocale = localeCountryKey.nz;    
      alternateCanonical = canonical.replace('/au/', '/nz/')
    } 
    if (countrylocale === localeCountryKey.nz){
      alternateCountrylocale = localeCountryKey.au;
      alternateCanonical = canonical.replace('/nz/', '/au/')
    }
  }

  return (        
    <>
      {title &&<title key="title">{title}</title>}
      {metaDescription && <meta name="description" content={metaDescription} key="description" />} 
      {metaKeywords && <meta name="keywords" content={metaKeywords} />} 
      {canonical && <link rel="canonical" href={canonical} key="canonical" />}
            
      {/* Add Internationalisation tags for Caroma AU & NZ to avoid duplicate content and canonical issues */}
      {/*add same country tag*/}
      {canonical && <link rel="alternate" hrefLang={`en-${countrylocale}`} href={canonical} />}
      {/*add other country tag*/}
      {canonical && alternateCountryUrlAvailable && <link rel="alternate" hrefLang={`en-${alternateCountrylocale}`} href={alternateCanonical} />}

      {stylesheet && <link rel="stylesheet" href={stylesheet}/>}

      {children}
    </>
  );
}
